import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import useFilters from "../../../../../hooks/useFilters"
import "react-datepicker/dist/react-datepicker.css"
import { registerLocale } from "react-datepicker"
import { it}   from "date-fns/locale/it"
registerLocale("it", it)

interface Props {
  filterKey: string
  placeholder: string
  initialDate: Date
}

const DateFilter: React.FC<Props> = ({ filterKey, placeholder, initialDate }) => {
  const [date, setDate] = useState<Date>(initialDate)
  const [limit, setLimit] = useState<Date | undefined>()
  const { addFilter, getActiveFilters } = useFilters()
  const filters = getActiveFilters()
  const removed = Object.keys(filters).includes(filterKey) ? false : true
  
  useEffect(() => {
    const minLimit = filterKey === 'endDate' && Object.keys(filters).includes('startDate') ? filters['startDate'] : undefined
    const maxLimit = filterKey === 'startDate' && Object.keys(filters).includes('endDate') ? filters['endDate'] : undefined

    if (minLimit) setLimit(minLimit)
    else setLimit(maxLimit)
  }, [getActiveFilters])

  const handleChange = (selectedDate: any) => {
    if (filterKey === 'endDate') selectedDate.setHours(23, 59, 59, 999)
    setDate(selectedDate)
    addFilter(filterKey, selectedDate.getTime())
  }

  return (
    <div className="date-filter">
      <DatePicker
        selected={removed ? null : date}
        onChange={handleChange}
        dateFormat={"dd MMMM yyyy"}
        locale="it"
        minDate={filterKey === 'endDate' && Object.keys(filters).includes('startDate') ? limit : undefined}
        maxDate={filterKey === 'startDate' && Object.keys(filters).includes('endDate') ? limit : new Date()}
        placeholderText={placeholder}
        className={`bg-cents-white h-10 w-[302px] text-sm rounded-2xl focus:ring-0 focus:outline-none border-transparent focus:border-cents-black block`}
      />
    </div>
  )
}

export default DateFilter;